<template>
  <div>
    <div class="d-flex justify-content-center mb-3">
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            :class="( aba == 'visao' || !aba ) ? 'active' : ''"
            @click.prevent="abrir('visao')"
          >Visão Geral</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            :class="aba == 'prestacao' ? 'active' : ''"
            @click.prevent="abrir('prestacao')"
          >Prestação de Contas</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            :class="aba == 'lancamento' ? 'active' : ''"
            @click.prevent="abrir('lancamento')"
          >Lançamento</a>
        </li>
        <li class="nav-item"> 
          <a
            class="nav-link"
            href="#"
            :class="aba == 'dre' ? 'active' : ''"
            @click.prevent="abrir('dre')"
          >DRE</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            :class="aba == 'fluxo' ? 'active' : ''"
            @click.prevent="abrir('fluxo')"
          >Fluxo de Caixa</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            :class="aba == 'extrato' ? 'active' : ''"
            @click.prevent="abrir('extrato')"
          >Extrato de Contas</a>
        </li>
        <li class="nav-item">
          <div class="btn-group dropleft">
            <button
              class="btn btn-light dropdown-toggle"
              type="button"
              id="triggerId"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-h ml-2"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="triggerId">
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'contas' ? 'active' : ''"
                @click.prevent="abrir('contas')"
              >Contas</a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'conciliacao' ? 'active' : ''"
                @click.prevent="abrir('conciliacao')"
              >Conciliação Bancária</a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'conciliacao-cartao' ? 'active' : ''"
                @click.prevent="abrir('conciliacao-cartao')"
              >Conciliação Cartão de Crédito</a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'impostos-retidos' ? 'active' : ''"
                @click.prevent="abrir('impostos-retidos')"
              >Impostos Retidos</a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'notas-suprimentos' ? 'active' : ''"
                @click.prevent="abrir('notas-suprimentos')"
                v-if="$store.state.unidade.suprimentos"
              >Notas do Suprimentos</a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'adiantamentos' ? 'active' : ''"
                @click.prevent="abrir('adiantamentos')"
              >Adiantamentos a Fornecedor</a>
              <a
                v-if="false && $store.state.user.id_usuario == 1"
                class="dropdown-item"
                href="#"
                :class="aba == 'adiantamentos_particulares' ? 'active' : ''"
                @click.prevent="abrir('adiantamentos_particulares')"
              >Adiantamentos Particulares</a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'pendentes' ? 'active' : ''"
                @click.prevent="abrir('pendentes')"
              >Pagamentos Particulares Pendentes</a>

              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'vales' ? 'active' : ''"
                @click.prevent="abrir('vales')"
              >Vales</a>

              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'glosas' ? 'active' : ''"
                @click.prevent="abrir('glosas')"
              >Posição de Recebimentos/Glosas</a>

              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'notas-fiscais' ? 'active' : ''"
                @click.prevent="abrir('notas-fiscais')"
              >Notas Fiscais</a>
              <a class="dropdown-item" href="#" :class="aba == 'dmed' ? 'active' : ''" @click.prevent="abrir('dmed')">
                DMED
              </a>

              <a class="dropdown-item" href="#" :class="aba == 'previsao-repasse' ? 'active' : ''" @click.prevent="abrir('previsao-repasse')">
                Apuração de Previsão de Repasses
              </a>
              <!-- Cadastros -->
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'fornecedor' ? 'active' : ''"
                @click.prevent="abrir('fornecedor')">
                Fornecedor/Prestador
              </a>
              <a
                class="dropdown-item"
                href="#"
                :class="aba == 'cadastro-contas' ? 'active' : ''"
                @click.prevent="abrir('cadastro-contas')">
                Contas
              </a>
              <!-- Fim Cadastros -->
              <template>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" :class="aba == 'fechamentos' ? 'active' : ''" @click.prevent="abrir('fechamentos')">
                  Fechamentos
                </a>
              </template>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <klingo-pendencia />

    <visao-geral v-if="aba == 'visao' || !aba" @abrirlanc="abrir_lancamentos" @abrirextrato="abrir_extrato" />
    <fluxo-de-caixa ref="fc" v-if="aba == 'fluxo' || aba == 'dre'" :aba="aba" @abrirlanc="abrir_lancamentos" @abririmp="abrir_impostos" />
    <lancamento v-if="aba == 'lancamento'" :parms="parms" />
    <cadastro-de-fornecedores v-if="aba == 'fornecedor'" />
    <prestacao-de-contas v-if="aba == 'prestacao'" />
    <extrato-de-contas v-if="aba == 'extrato'" :parms="parms" />
    <arquivo-dmed v-if="aba == 'dmed'" />
    <conciliacao-bancaria v-if="aba == 'conciliacao'" />
    <notas-fiscais v-if="aba == 'notas-fiscais'" />
    <impostos-retidos v-if="aba == 'impostos-retidos'" :parms="parms" />
    <conciliacao-cartao v-if="aba == 'conciliacao-cartao'" />
    <notas-do-estoque v-if="aba == 'notas-suprimentos'" />
    <fechamento v-if="aba == 'fechamentos'" />
    <adiantamento-fornecedor v-if="aba == 'adiantamentos'" />
    <particular-pagamentos-pendentes v-if="aba == 'pendentes'" />
    <adiantamentos-particulares-geral v-if="aba == 'adiantamentos_particulares'" />
    <dash-glosas :financeiro="true" v-if="aba == 'glosas'" />
    <contas-sinteticas v-if="aba == 'contas'" />
    <cadastro-financeiro-contas :financeiro="true" v-if="aba == 'cadastro-contas'" />
    <vale v-if="aba == 'vales'" />
    <apurar-previsao-repasse v-if="aba == 'previsao-repasse'" />

  </div>
</template>

<script>
import VisaoGeral from "./VisaoGeral.vue";
import FluxoDeCaixa from "./FluxoDeCaixa.vue";
import Lancamento from "./Lancamento.vue";
import CadastroDeFornecedores from "./CadastroDeFornecedores.vue";
import PrestacaoDeContas from "./PrestacaoDeContas.vue";
import ExtratoDeContas from "./ExtratoDeContas.vue";
import ArquivoDmed from "./ArquivoDmed.vue";
import ConciliacaoBancaria from "./ConciliacaoBancaria.vue";
import ImpostosRetidos from './ImpostosRetidos.vue';
import NotasFiscais from "./NotasFiscais.vue";
import ConciliacaoCartao from "./ConciliacaoCartoes.vue";
import NotasDoEstoque from './NotasDoEstoque.vue';
import Fechamento from './Fechamento.vue';
import AdiantamentoFornecedor from './AdiantamentoFornecedor.vue';
import ParticularPagamentosPendentes from './ParticularPagamentosPendentes.vue';
import KlingoPendencia from '../../shared/KlingoPendencia.vue';
import AdiantamentosParticularesGeral from './AdiantamentosParticularesGeral.vue';
import DashGlosas from '../faturamento/DashGlosas.vue';
import ContasSinteticas from './ContasSinteticas.vue';
import CadastroFinanceiroContas from '../../cadastros/items/CadastroFinanceiroContas.vue';
import Vale from './Vale.vue';
import ApurarPrevisaoRepasse from './ApurarPrevisaoRepasse.vue';

export default {
  data() {
    return {
      dados: null,
      parms: null,
    };
  },

  components: {
    VisaoGeral,
    FluxoDeCaixa,
    Lancamento,
    CadastroDeFornecedores,
    PrestacaoDeContas,
    ExtratoDeContas,
    ArquivoDmed,
    ConciliacaoBancaria,
    ImpostosRetidos, 
    NotasFiscais,
    ConciliacaoCartao,
    NotasDoEstoque,
    Fechamento,
    AdiantamentoFornecedor,
    ParticularPagamentosPendentes,
    KlingoPendencia,
    AdiantamentosParticularesGeral,
    DashGlosas,
    ContasSinteticas,
    CadastroFinanceiroContas,
    Vale,
    ApurarPrevisaoRepasse
  },

  props: ['aba'],

  methods: {
    abrir(aba) { 
        if ( aba != this.aba ) { 
          this.$router.push({ path: '/financeiro/' + aba });

          if ( aba == 'dre' || aba == 'fluxo' ) { 
            this.$nextTick(() => {
              if ( this.$refs.fc ) { 
                this.$refs.fc.remount(); 
              }
            });      
          }
        }
    },

    abrir_impostos(parms) {
      this.parms = parms;
      this.abrir("impostos-retidos");

      this.$nextTick(() => {
        this.parms = null;
      });
    },
    
    abrir_lancamentos(parms) {
      this.parms = parms;
      this.abrir("lancamento");

      this.$nextTick(() => {
        this.parms = null;
      });
    },

    abrir_extrato(parms) {
      this.parms = parms;
      this.abrir("extrato");

      this.$nextTick(() => {
        this.parms = null;
      });
    },
  },


};
</script>